// @flow
import type {
  Node,
  StatelessFunctionalComponent as ComponentType
} from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { GRID_GUTTER, MAX_WIDTH } from 'utils/theme';
import columnWidth from 'utils/columnWidth';

/*
We need this file as css GRID GUTTERS are not supported on IE 11, this is the workaround for that
If you don't need or gutters using CSS grid with area-templates is acceptable.
Based on https://css-tricks.com/css-grid-in-ie-faking-an-auto-placement-grid-with-gaps/
 */

type ColumnsType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

const GridWrapper = styled.div`
  max-width: ${MAX_WIDTH};
  overflow: hidden;
`;

const GridRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: -${GRID_GUTTER};
  padding: ${GRID_GUTTER} 0 0 ${GRID_GUTTER};
`;

export const Grid = ({ children, ...props }: { children: Node }) => (
  <GridWrapper {...props}>
    <GridRow>{children}</GridRow>
  </GridWrapper>
);

export const Cell: ComponentType<{
  span: ColumnsType,
  start: ColumnsType
}> = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  ${({ span }) => {
    const width = columnWidth(span);
    return css`
      width: ${width}%;
      min-width: ${width}%;
      max-width: ${width}%;
    `;
  }};
  border-style: solid;
  border-color: transparent;
  border-width: 0 ${GRID_GUTTER} ${GRID_GUTTER} 0;
`;
